import { NgModule } from "@angular/core";

import { WebHeaderComponent } from "./web-header.component";

@NgModule({
  imports: [WebHeaderComponent],
  exports: [WebHeaderComponent],
})
export class HeaderModule {}
